import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorToastService } from './http-error-toast.service';
import { HTTP_ERROR_TOAST_REQUEST, SUPPRESS_HTTP_ERROR_TOAST } from './http-error-toast.context';

@Injectable()
export class HttpErrorToastInterceptor implements HttpInterceptor {
  constructor(private readonly errorToastService: HttpErrorToastService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.shouldObserve(request)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (this.isHttpError(error)
          && !request.context.get(SUPPRESS_HTTP_ERROR_TOAST)
          && !this.isInvalidLogin(request, error)) {
          this.errorToastService.report(request.context.get(HTTP_ERROR_TOAST_REQUEST) ?? request, error);
        }
        return throwError(() => error);
      })
    );
  }

  private shouldObserve(request: HttpRequest<unknown>): boolean {
    if (!request.url.includes('/api/v1/') || request.context.get(SUPPRESS_HTTP_ERROR_TOAST)) {
      return false;
    }

    if (request.url.includes('/auth/refresh')) {
      return false;
    }

    return true;
  }

  private isInvalidLogin(request: HttpRequest<unknown>, error: HttpErrorResponse): boolean {
    return request.method === 'POST'
      && /\/api\/v1\/auth\/login\/?(?:[?#]|$)/.test(request.url)
      && error.status === HttpStatusCode.Unauthorized;
  }

  private isHttpError(error: unknown): error is HttpErrorResponse {
    return error instanceof HttpErrorResponse || (
      typeof error === 'object'
      && error !== null
      && typeof (error as { status?: unknown }).status === 'number'
      && 'headers' in error
    );
  }
}
